enum DashboardTab {
  DASHBOARDS = 'dashboards',
  TEMPLATES = 'templates',
}

/**
 * Font size options for the value displayed in single-value widgets (tile/metric)
 */
enum TileFontSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

/**
 * Metadata stored for each dashboard component
 */
interface ComponentMetadata {
  selectedTargetId?: string;
  showTrendLines?: boolean;
  tileFontSize?: TileFontSize;
  showTotal?: boolean;
}

/**
 * Nested structure for tracking component metadata (targets, settings, etc.)
 * Shape: { dashboardId: { componentId: metadata } }
 */
type WidgetMetadata = {
  [dashboardId: string]: {
    [componentId: string]: ComponentMetadata;
  };
};

interface State {
  selectedTab: DashboardTab;
  selectedTargets: WidgetMetadata;
}

export { DashboardTab, TileFontSize };
export type { ComponentMetadata, State, WidgetMetadata };
